// extracted by mini-css-extract-plugin
module.exports = {"infoHolder":"RouteGoogleMaps_infoHolder__V8kqB"};